

<div>
  <button *ngIf="token" class="btn btn-primary" style="float: right;" (click)="Back()">Back</button>
</div>
<div class="container-fluid">
  <div class="row">
    <div class="col info-padding">

      <h2 class="heading">How it Works</h2>

      <video controls src="../../../../assets/Images/ezepay-works.mp4" type="video/mp4" media="all and (min-width:480px)"></video>
    </div>
  </div>
</div>
